import React, { Component, Fragment } from 'react';
import '../../../../node_modules/react-datetime/css/react-datetime.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel';
import moment from 'moment';
import ReactTooltip from 'react-tooltip'
import {
    _addNotification, _addNotificationError,
    formatDate, allowNumericWithdecimal, getWeekStartEndDates, getMonthStartEndDates,
    getTodayStartEndDates, showFile,
    convertTwoDecimalPoint, getSessionStartEndDates, getModuleEnum, getAccessLevelByModule, getLastMonthStartEndDates
} from "../../../server/util";
import { currency_symbol, date_format } from '../../../server/constants'
import { get, postWithHeaders, postWithHeadersResponse, _delete } from "../../../server/actions";
import ReactTable from 'react-table';
import '../../../../src/assets/css/react-table.css';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
var converter = require('number-to-words');
var _ = require('lodash');
const checkboxProps = {
    getTheadProps: () => {
        return {
            style: {
                backgroundColor: "#D2D7D4", fontWeight: 'bold'
                // color: selected ? 'white' : 'inherit',
            },
            className: "bg-success base-reverse"
        };
    },
    getTableProps: () => {
        return {
            className: "table table-hover"
        }
    },
};
class BcacPayments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bcacPayDataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            columns: [],
            data: [],
            tabIndex: 0
        }
    }
    componentDidMount = () => {
        this.getDataByGrade(0);
    }
    init = () => {
        this.setState({ bcacPayDataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() } }, () => {
            this.getDataByGrade(0);
        })
    }
    buildBCACDataFormatForExport = () => {
        let fData = [];
        this.state.data.map(item => {
            fData.push(
                [
                    { value: item.studentId || '' },
                    { value: item.fullName || '' },
                    { value: item.pin || '' },
                    { value: item.grade || '' },
                    { value: item.transactionDateTime || '' },
                    { value: item.packageType || '' },
                    { value: item.paymentType || '' },
                    { value: item.transferId || '' },
                    { value: item.packageName || '' },
                    { value: item.startDt },
                    { value: item.endDt },
                    { value: item.amount || 0.00 }
                ]);
        })
        return (
            [{
                columns: [
                    { title: 'Student Id' },
                    { title: 'Name' },
                    { title: 'Pin' },
                    { title: 'Grade' },
                    { title: 'Date' },
                    { title: 'Package Type' },
                    { title: 'Payment Type' },
                    { title: 'Transaction Id' },
                    { title: 'Package Name' },
                    { title: 'Start Date' },
                    { title: 'End Date' },
                    { title: `Amount (${currency_symbol()})` }],
                data: fData
            }]
        )
    }
    getColumns = () => {
        return [
            {
                Header: "Name",
                accessor: "fullName",
                width: 200
            },
            {
                Header: "Pin",
                accessor: "pin",
                width: 100
            },
            {
                Header: "Date",
                //accessor: "transactionDateTime",
                Cell: ({ row }) => <span>{moment(row._original.transactionDateTime).format(date_format() + ' ' + 'hh:mm:ss a')}</span>,
                width: 200
            },
            {
                Header: "Package Type",
                accessor: "packageType",
                width: 100
            },
            {
                Header: "Package",
                accessor: "packageName",
            },
            {
                Header: "Payment Type",
                accessor: "paymentType",
            },
            {
                Header: "Transaction Id",
                id: 'transferId',
                width: 100,
                Cell: row => {
                    return (
                        <Fragment>
                            <a data-tip data-for={'ah-' + row.index}>{row.original.transferId}</a>
                            <ReactTooltip id={'ah-' + row.index} aria-haspopup='true' type="dark" effect="float">
                                <div>
                                    {row.original.transferId}
                                </div>
                            </ReactTooltip>
                        </Fragment>
                    )
                }
            }, {
                Header: "Start Date",
                Cell: ({ row }) => (
                    <span>{row._original.startDt ? moment(row._original.startDt).format(date_format()) : ''}</span>
                ),
                //accessor: "startDt",
                width: 100
            }, {
                Header: "End Date",
                Cell: ({ row }) => (
                    <span>{row._original.endDt ? moment(row._original.endDt).format(date_format()) : ''}</span>
                ),
                //accessor: "endDt",
                width: 100
            },
            {
                Header: `Amount`,
                id: 'amount',
                width: 100,
                accessor: row => {
                    return (
                        <div style={{ textAlign: "right" }}>
                            {
                                currency_symbol(this.state.mealSchoolId) + ' ' + convertTwoDecimalPoint(row.amount)
                            }
                        </div>
                    );
                }
            }
        ]
    }
    filterSchool = () => {
        let s = document.getElementById('searchBcac').value;
        let filteredData = this.state.students;
        let searchedSchool = [];
        if (s.length > 0) {
            filteredData.forEach(obj => {
                if (obj.stdFName != null && (obj.stdFName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.stdLName != null && (obj.stdLName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.packageName != null && (obj.packageName.replace(/[()\-" ]+/g, '').toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.type != null && (obj.type.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
                else if (obj.transactionId != null && (obj.transactionId.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
                else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            //.replace(/[()\-" ]+/g, '')
            this.setState({ data: searchedSchool })
        }
        else {
            this.setState({ data: searchedSchool.length == 0 ? filteredData : searchedSchool })
        }
        this.forceUpdate();
    };
    getDataByGrade = (gradeName, ispdf = false) => {
        let teachers = [];
        let studentsByGrade = [];
        this.setState({ loading: true });
        let schoolId = sessionStorage.getItem('SchoolId');
        let filterObj = this.state.bcacPayDataFilter
        let date = {}
        if (filterObj.tdate === 'W') {
            date = getWeekStartEndDates(new Date())
        } else if (filterObj.tdate === 'M') {
            date = getMonthStartEndDates(new Date())
        } else if (filterObj.tdate === 'LM') {
            date = getLastMonthStartEndDates(new Date())
        } else if (filterObj.tdate === 'Y') {
            date = getSessionStartEndDates(sessionStorage.getItem('schoolYearValue'))
        } else if (filterObj.tdate === 'C') {
            date = { startDate: filterObj.sdate, endDate: filterObj.edate }
        } else {
            date = getTodayStartEndDates(new Date());
        }
        (get(`/reports/packagesTrx?mealSchoolId=${schoolId}&schoolYear=${sessionStorage.getItem('schoolYearValue')}&startDate=${moment(date.startDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(date.endDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&isExport=${ispdf}&access_token=`))
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                if (ispdf) {
                    return response.blob();
                } else {
                    return response.json();
                }
            }).then(data => {
                if (ispdf) {
                    let filename = 'BCACPayment.pdf';
                    showFile(data, filename);
                    this.setState({ loading: false });
                } else {

                    console.log('data', data);
                    const stData = data['response'] || [];
                    let activeStData = stData;
                    if ((gradeName || '0') == '0') {
                        return activeStData.map(item => {
                            let fullName = `${item.stdFName} ${item.stdLName}`;
                            return {
                                fullName,
                                ...item
                            };
                        });
                    } else {
                        activeStData.map(item => { //pushes all students for grade selected into an array
                            let _gradeName = item.grade;
                            if (_gradeName === gradeName) {
                                studentsByGrade.push(item);
                            }
                        });
                        return studentsByGrade.map(item => {
                            let fullName = `${item.stdFName} ${item.stdLName}`;
                            return {
                                fullName,
                                ...item
                            };
                        });
                    }
                }
            }).then(data => {
                if (ispdf) {
                    this.setState({ loading: false })
                    return true;
                } else {
                    this.setState({ studentsCount: studentsByGrade.length });
                    let columns = this.getColumns();
                    this.setState({
                        students: data,
                        data: data,
                        columns: columns,
                        loading: false,
                        studentCount: data.length
                    })
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)
                }
            );
    }
    render() {

        return (
            <Fragment>
                <div className="panel panel-p1 panel-primary">
                    <div className="panel-heading text-center">
                        <h3 className="panel-title" style={{ display: 'inline' }}>BCAC Payments</h3>
                        <div style={{
                            display: 'inline-block',
                            backgroundColor: 'transparent',
                            marginTop: '-7px',
                            float: 'right',
                            borderRadius: '3px'
                        }}>
                            <div className="btn-group">
                                <button className="btn-link btn-sm dropdown-toggle" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                    <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                            onClick={() => { this.getDataByGrade(this.state.tabIndex, true); }}
                                            target='_blank'
                                        ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                    </li>
                                    <li>
                                        <TmExportExcel id="Bcacpackagedetails"
                                            name={"Bcac package details"}
                                            filename={"Bcac package details"}
                                            element={<a title="Click to Download Excel"
                                                style={{
                                                    display: 'block',
                                                    padding: '3px 20px',
                                                    clear: 'both',
                                                    fontWeight: '400',
                                                    lineHeight: 1.42857143,
                                                    color: '#333',
                                                    whiteSpace: 'nowrap',
                                                    cursor: 'pointer'
                                                }}
                                            ><i className="fa fa-file-excel-o" /> Excel</a>}
                                            dataSet={this.buildBCACDataFormatForExport()}
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="alert alert-info ">
                                    <div onChange={(event) => {
                                        let bcacPayDataFilter = this.state.bcacPayDataFilter;
                                        bcacPayDataFilter.tdate = event.target.value;
                                        this.setState({ bcacPayDataFilter: bcacPayDataFilter }, () => {
                                            if (this.state.bcacPayDataFilter.tdate !== 'C') {
                                                this.getDataByGrade(this.state.tabIndex);;
                                            }
                                        })
                                    }}>
                                        <label class="rbcontainer">Today
                                            <input type="radio" name="bdrange" value="D" checked={this.state.bcacPayDataFilter.tdate === 'D'} />
                                            <span className="rbcheckmark"></span>
                                        </label>
                                        <label class="rbcontainer">This Week
                                            <input type="radio" name="bdrange" value="W" checked={this.state.bcacPayDataFilter.tdate === 'W'} />
                                            <span className="rbcheckmark"></span>
                                        </label>
                                        <label class="rbcontainer">This Month
                                            <input type="radio" name="bdrange" value="M" checked={this.state.bcacPayDataFilter.tdate === 'M'} />
                                            <span className="rbcheckmark"></span>
                                        </label>
                                        <label class="rbcontainer">Last Month
                                            <input type="radio" name="bdrange" value="LM" checked={this.state.bcacPayDataFilter.tdate === 'LM'} />
                                            <span className="rbcheckmark"></span>
                                        </label>
                                        <label class="rbcontainer">This Year
                                            <input type="radio" name="bdrange" value="Y" checked={this.state.bcacPayDataFilter.tdate === 'Y'} />
                                            <span className="rbcheckmark"></span>
                                        </label>
                                        <label class="rbcontainer">Custom Date Range
                                            <input type="radio" name="bdrange" value="C" checked={this.state.bcacPayDataFilter.tdate === 'C'} />
                                            <span className="rbcheckmark"></span>
                                        </label>
                                        {
                                            this.state.bcacPayDataFilter.tdate === 'C' ?
                                                <DateRangePicker startDate={this.state.bcacPayDataFilter.sdate} endDate={this.state.bcacPayDataFilter.edate} onApply={(event, picker) => {
                                                    let bcacPayDataFilter = this.state.bcacPayDataFilter;
                                                    bcacPayDataFilter.sdate = picker.startDate._d;
                                                    bcacPayDataFilter.edate = picker.endDate._d;
                                                    this.setState({ bcacPayDataFilter: bcacPayDataFilter }, () => {
                                                        this.getDataByGrade(this.state.tabIndex);
                                                    })

                                                    console.log('sdate --:', event, picker)
                                                }}>
                                                    <button className="btn btn-xs bg-color-1" style={{ margin: '0px' }}><i className="fa fa-calendar"></i></button>
                                                </DateRangePicker> : null
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <Tabs
                                //selectedIndex={this.state.tabIndex} 
                                // onSelect={index => this.setState({tabIndex:index})}
                                >
                                    <TabList>

                                        {/*  <Tab onClick={() => {
                                                                this.setState({ selectAll: false,tabIndex:0 })
                                                                this.getDataByGrade(0) ///this loads all students when All Grades is selected
                                                            }}>All Grades</Tab> */}
                                        {this.props.gradeList.map((item, k) => {
                                            return <Tab onClick={() => {
                                                this.state.tabIndex = k;
                                                this.setState({ selectAll: false })
                                                this.getDataByGrade(item.value);
                                            }}> {item.label}</Tab>
                                        }, this)}
                                        {/* {this.props.grades.map(function (key) {
                                                                return <Tab onClick={() => {
                                                                    let _tabIndex = typeof key === "number" ? converter.toWords(key) : key;
                                                                    this.setState({ selectAll: false,tabIndex:_tabIndex },()=>{
                                                                        this.getDataByGrade(typeof key === "number" ? converter.toWords(key) : key);
                                                                    })                                                                    
                                                                }}> {this.state.tabIndex === (typeof key === "number" ? converter.toWords(key) : key) ? "Grade " + key : key}</Tab>
                                                            }, this)
                                                            }   */}
                                    </TabList>
                                    <TabPanel>
                                        <div className="row">
                                            <div className="col-xs-12 pull-left">
                                                <input type="text" id="searchBcac"
                                                    className="search form-control"
                                                    style={{
                                                        float: 'left',
                                                        margin: '5px 0'
                                                    }}
                                                    name="search"
                                                    placeholder="Search.."
                                                    onKeyUp={this.filterSchool} />
                                            </div>
                                        </div>
                                        <ReactTable className="-striped -highlight"
                                            ref={r => (this.checkboxTable = r)}
                                            data={_.orderBy(this.state.data, ['stdLName', 'stdFName'], ['asc'])}
                                            columns={this.state.columns}
                                            defaultPageSize={10}
                                            {...checkboxProps}
                                        />
                                    </TabPanel>
                                    {
                                        this.props.gradeList.map((key) => {
                                            return (
                                                <TabPanel>
                                                    <div className="row">
                                                        <div className="col-xs-12 pull-left">
                                                            <input type="text" id="searchBcac"
                                                                className="search form-control"
                                                                style={{
                                                                    float: 'left',
                                                                    margin: '5px 0'
                                                                }}
                                                                name="search"
                                                                placeholder="Search.."
                                                                onKeyUp={this.filterSchool} />
                                                        </div>
                                                    </div>
                                                    <ReactTable className="-striped -highlight"
                                                        ref={r => (this.checkboxTable = r)}
                                                        data={this.state.data}
                                                        // data={_.orderBy(this.state.data, ['stdLName', 'stdFName'], ['asc'])}
                                                        columns={this.state.columns}
                                                        defaultPageSize={10}
                                                        {...checkboxProps}

                                                    />
                                                </TabPanel>)
                                        }, this)}
                                </Tabs>
                            </div>
                        </div>

                    </div>
                </div>

            </Fragment>
        );
    }
}

export default BcacPayments;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/PaymentReports/bcacPayments.jsx